import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  list: null,
  loading: false
}

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setOrganizationsList: (state, action) => ({ ...state, list: action.payload }),
    setLoading: (state, action) => ({ ...state, loading: action.payload })
  }
})

export const { setOrganizationsList, setLoading } = organizationsSlice.actions
export default organizationsSlice.reducer
